import type { UserInstrumentClassificationDto } from "@eu.mdotm.api/sphere";
import { Icon } from "@mdotm/shadcn/legacy/components";
import { noop, unpromisify } from "@mdotm/shadcn/legacy/utils";
import type { DefaultMenuItem, MenuItemDef } from "ag-grid-community";
import { renderToStaticMarkup } from "react-dom/server";
import { instrumentsRepository } from "../repository";
import { spawnInstrumentCustomizationSidePanel } from "./SidePanelColumnsAdder";
import { columnChooserMenuItemDef } from "$root/third-party-integrations/ag-grid/ag-grid";
import { spawnInstrumentCustomisationDeleteDialog } from "./delete-dialog";

export function mainMenuItemsForUserClassification(
	classification: UserInstrumentClassificationDto,
): (DefaultMenuItem | MenuItemDef)[] {
	return [
		"sortAscending",
		"sortDescending",
		"separator",
		"pinSubMenu",
		"separator",
		"autoSizeThis",
		"autoSizeAll",
		"separator",
		columnChooserMenuItemDef,
		"resetColumns",
		"separator",
		{
			icon: renderToStaticMarkup(<Icon size={18} icon="Edit" />),
			name: "Edit",
			action() {
				spawnInstrumentCustomizationSidePanel({
					mode: "edit",
					classification,
					onSubmitAsync: async (newClassification) => {
						await instrumentsRepository.updateClassification(newClassification.classificationUuid!, newClassification);
					},
				}).catch(noop);
			},
		},
		{
			icon: renderToStaticMarkup(<Icon size={18} icon="Delete" />),
			name: "Delete",
			// ag-grid calls `action` and discards its result, so the lookup that precedes the dialog
			// needs its own rejection handler.
			action: unpromisify(async () => {
				const queryData = await instrumentsRepository.checkColumnInvestments.fetchQuery(
					classification.classificationUuid!,
				);
				const investmentsByOwner = Object.entries(queryData);

				spawnInstrumentCustomisationDeleteDialog({
					type: "delete-column",
					investmentsUsedIn: investmentsByOwner,
					onContinue: async () => {
						investmentsByOwner.length > 0
							? noop()
							: instrumentsRepository.deleteClassification(classification.classificationUuid!);
					},
				}).catch(noop);
			}),
		},
	];
}
